import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { ActionsUnion } from '../types';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { Barrier, BarrierLog } from './types';

export const Actions = {
  getBarriers: () => createAction(ActionTypes.GET_BARRIERS),
  getBarriersSuccess: (data: Barrier[]) => createAction(ActionTypes.GET_BARRIERS_SUCCESS, data),
  getBarriersError: (error: RestErrorResponse) => createAction(ActionTypes.GET_BARRIERS_ERROR, error),

  createNewBarrier: () => createAction(ActionTypes.CREATE_NEW_BARRIER),
  createNewBarrierSuccess: () => createAction(ActionTypes.CREATE_NEW_BARRIER_SUCCESS),
  createNewBarrierError: (error: RestErrorResponse) => createAction(ActionTypes.CREATE_NEW_BARRIER_ERROR, error),

  editBarrierDevice: () => createAction(ActionTypes.EDIT_BARRIER_DEVICE),
  editBarrierDeviceSuccess: () => createAction(ActionTypes.EDIT_BARRIER_DEVICE_SUCCESS),
  editBarrierDeviceError: (error: RestErrorResponse) => createAction(ActionTypes.EDIT_BARRIER_DEVICE_ERROR, error),

  deleteBarrierDevice: () => createAction(ActionTypes.DELETE_BARRIER_DEVICE),
  deleteBarrierDeviceSuccess: () => createAction(ActionTypes.DELETE_BARRIER_DEVICE_SUCCESS),
  deleteBarrierDeviceError: (error: RestErrorResponse) => createAction(ActionTypes.DELETE_BARRIER_DEVICE_ERROR, error),

  getBarrier: () => createAction(ActionTypes.GET_BARRIER),
  getBarrierSuccess: (barrier: Barrier) => createAction(ActionTypes.GET_BARRIER_SUCCESS, barrier),
  getBarrierError: (error: RestErrorResponse) => createAction(ActionTypes.GET_BARRIER_ERROR, error),

  getBarrierLogs: () => createAction(ActionTypes.GET_BARRIER_LOGS),
  getBarrierLogsSuccess: (barrierLogs: BarrierLog[]) => createAction(ActionTypes.GET_BARRIER_LOGS_SUCCESS, barrierLogs),
  getBarrierLogsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_BARRIER_LOGS_ERROR, error)
};

export type BarrierActions = ActionsUnion<typeof Actions>;
